function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 20,
    r: 3,
    fill: "#CCC",
    style: {
      fill: "#2f6786",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3,
    fill: "#CCC",
    style: {
      fill: "#2f6786",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20,
    r: 3,
    fill: "#CCC",
    style: {
      fill: "#2f6786",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotMenu);
export default __webpack_public_path__ + "static/media/dot_menu.c9033f65d63d34bf908960a7b4c2ab77.svg";
export { ForwardRef as ReactComponent };